import { useEffect, useState } from "react";
import { useHistory } from "react-router";

// Styles
import { Wrapper } from "./styles";

export default function NaoEncontrado() {
  const history = useHistory();
  const [segundosRestantes, setSegundosRestantes] = useState(5);

  useEffect(() => {
    while (segundosRestantes !== 0) {
      setTimeout(() => {
        setSegundosRestantes(segundosRestantes - 1);
      }, 1000);
      break;
    }
    if (segundosRestantes === 0) history.push("/");
    return () => clearTimeout(segundosRestantes);
  }, [history, segundosRestantes]);

  return (
    <Wrapper>
      <h2>Página não encontrada!</h2>
      <h3>Você será redirecionado para a home em {segundosRestantes}s</h3>
    </Wrapper>
  );
}
